import React, { useEffect } from "react";
import { BrowserRouter, Outlet, Route, Routes, useLocation } from "react-router-dom";
import SiteHeader from "./components/SiteHeader";
import HomeHero from "./components/home/HomeHero";
import ExpertisesSection from "./components/home/ExpertisesSection";
import StudiesSection from "./components/home/StudiesSection";
import WorkflowSection from "./components/home/WorkflowSection";
import ReinforcementSection from "./components/home/ReinforcementSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import AnimationToggle from "./components/AnimationToggle";
import ScrollToHash from "./components/ScrollToHash";
import useReveal from "./lib/useReveal";
import GalleryPage from "./pages/GalleryPage";
import DocumentsPage from "./pages/DocumentsPage";
import VisualisationPage from "./pages/VisualisationPage";
import "./styles/si2t-ui.css";
import "./styles/industrial-background.css";

function Home() {
  useReveal();
  return (
    <main id="main" data-testid="home-page">
      <HomeHero />
      <ExpertisesSection />
      <StudiesSection />
      <WorkflowSection />
      <ReinforcementSection />
      <ContactSection />
    </main>
  );
}

const pageMetadata = {
  "/": {
    title: "SI2T — Bureau d'études industriel externalisé | Conception 2D/3D, mise en plan",
    description: "SI2T — Solutions d'Ingénierie Industrielle et Technique. Bureau d'études externalisé : conception 2D/3D, mise en plan et dossiers de fabrication pour les TPE et PME industrielles.",
    canonical: "https://si2tsolutions.fr/",
  },
  "/galerie": {
    title: "Galerie de projets et études types | SI2T",
    description: "Découvrez les études types SI2T : rendus CAO, fiches illustratives et aperçus de plans pour la conception mécanique et les structures métalliques.",
    canonical: "https://si2tsolutions.fr/galerie",
  },
};

function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = pageMetadata[pathname];
    document.title = page?.title || "SI2T";
    for (const [name, content] of [
      ["description", page?.description || "SI2T, bureau d'études techniques."],
      ["robots", page ? "index, follow" : "noindex, follow"],
    ]) {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    }
    let canonical = document.querySelector('link[rel="canonical"]');
    if (page) {
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", page.canonical);
    } else {
      canonical?.remove();
    }
  }, [pathname]);
  return null;
}

function Layout() {
  return <><SiteHeader /><Outlet /><Footer /><AnimationToggle /></>;
}

export default function SiteApp() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageMetadata />
        <ScrollToHash />
        <a href="#main" className="skip-link">Aller au contenu</a>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/galerie" element={<GalleryPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/visualisation" element={<VisualisationPage />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
